var exports = {
  "K": "x93eb46d8--7a86c5--icon",
  "f": "x93eb46d8--7a86c5--expand",
};

module.exports = exports;
